/**
 * Blocks the context menu and the drag-away on every image, delegated on the
 * document since images arrive later too. Scoped to images: killing the context
 * menu page-wide would also take away open-in-new-tab, copy and back.
 */
(function () {
  var CIBLES = 'img, picture, svg, canvas, video';

  function surImage(event) {
    var el = event.target;
    return !!(el && el.closest && el.closest(CIBLES));
  }

  document.addEventListener('contextmenu', function (event) {
    if (surImage(event)) event.preventDefault();
  });

  // Dragging a picture onto the desktop is the other one-gesture grab.
  document.addEventListener('dragstart', function (event) {
    if (surImage(event)) event.preventDefault();
  });
})();
